<template>
  <div class="pc_main-info">
    <div>
      <div class="price-main">
        <el-form
          ref="ruleForm"
          label-position="top"
          label-width="80px"
          :model="form"
          :rules="rules"
          :hide-required-asterisk="true"
        >
          <h5>{{ $t('PCUserInfo.index.647kboa03ks0') }}</h5>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item :label="$t('PCUserInfo.index.647kboa06ys0')" prop="userName">
                <el-input
                  v-model="form.userName"
                  maxlength="64"
                  :placeholder="$t('PCUserInfo.index.647kboa05s1d')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- <el-form-item :label="$t('PCUserInfo.index.647kboa078s0')">
                <el-input v-model="form.mobile"  maxlength="16"></el-input>
              </el-form-item> -->
              <el-form-item
                :label="$t('PCUserInfo.index.647kboa078s0')"
                prop="mobile"
                class="input-mobileNumber-item"
              >
                <el-input
                  ref="input-mobileNumber"
                  v-model="form.mobile"
                  :placeholder="$t('components.section7.646ns2k5gx40')"
                  :maxlength="16"
                  @focus="focus"
                >
                  <el-select
                    slot="prepend"
                    v-model="form.mobileAreaCode"
                    :popper-append-to-body="false"
                    style="width: 160px"
                  >
                    <img slot="prefix" :src="getFlagUrl" alt="" style="width: 24px; height: 24px" />
                    <el-option
                      v-for="(item, key) in mobileAreaCode"
                      :key="item.areaCode"
                      :value="item.areaCode"
                    >
                      <div style="display: flex; align-items: center">
                        <img
                          :src="item.flagUrl"
                          alt=""
                          style="width: 24px; height: 24px; margin-right: 10px"
                        />
                        {{ item.areaCode }} {{ item.countryName }}
                      </div>
                    </el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <h5>{{ $t('PCUserInfo.index.647kboa07d00') }}</h5>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item :label="$t('PCUserInfo.index.647kboa07jk0')" prop="countryCode">
                <el-select
                  v-model="form.countryCode"
                  filterable
                  :placeholder="$t('PCUserInfo.index.647kboa07p80')"
                  style="width: 100%"
                  @change="getPostCode('')"
                >
                  <el-option
                    v-for="item in countryList"
                    :key="item.countryCode"
                    :label="item.country"
                    :value="item.countryCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('PCUserInfo.index.647kboa08b40')" prop="pinCode">
                <el-select
                  v-model="form.pinCode"
                  filterable
                  :placeholder="$t('PCUserInfo.index.647kboa07p80')"
                  :remote-method="remotePinCode"
                  remote
                  style="width: 100%"
                  max
                  @change="getCities('')"
                >
                  <el-option
                    v-for="item in postCodeList"
                    :key="item.postCode"
                    :label="item.postCode"
                    :value="item.postCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('PCUserInfo.index.647kboa08h00')" prop="city">
                <el-select
                  v-model="form.city"
                  filterable
                  :placeholder="$t('PCUserInfo.index.647kboa07p80')"
                  :remote-method="remoteCity"
                  style="width: 100%"
                  remote
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.placeName"
                    :label="item.placeName"
                    :value="item.placeName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="idCard">
                <template #label>
                  <div class="label-with-tooltip">
                    <span>
                      {{ $t('PCUserInfo.index.647kboa0idc0') }}
                    </span>
                    <el-tooltip effect="dark" placement="top">
                      <div slot="content" style="white-space: pre-line">
                        {{ $t('PCUserInfo.index.647kboa0idc1') }}
                      </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                </template>
                <el-input
                  v-model="form.idCard"
                  maxlength="30"
                  :placeholder="$t('PCUserInfo.index.647kboa05s1d')"
                  @input="handleInput"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <!-- <el-form-item :label="$t('PCUserInfo.index.647kboa08zc0')">
                <el-input
                  v-model="form.address"
                  maxlength="255"
                  :placeholder="$t('PCUserInfo.index.647kboa05s1d')"
                ></el-input>
              </el-form-item> -->
              <el-form-item :label="$t('PCUserInfo.index.647kboa08zc0')" class="addressInput">
                <el-input v-model="form.address" maxlength="105" show-word-limit :placeholder="$t('PCUserInfo.index.addreddPlaceholder')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <h5>{{ $t('PCUserInfo.index.647kboa09440') }}</h5>
          <el-row :gutter="40">
            <!-- <el-col :span="12">
              <el-form-item label="BIC" prop="bic">
                <el-input v-model="form.bic" maxlength="32"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <!-- <el-form-item label="IBAN" prop="iban">
                <el-input v-model="formattedIBAN" maxlength="42" @input="formatIBAN" ></el-input>
              </el-form-item> -->

              <el-form-item prop="iban">
                <template #label>
                  <div class="label-with-tooltip">
                    <span> IBAN </span>
                    <el-tooltip effect="dark" placement="top">
                      <div slot="content" style="white-space: pre-line">
                        {{ $t('PCUserInfo.index.ibanTip') }}
                      </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                </template>
                <el-input
                  v-model="formattedIBAN"
                  maxlength="42"
                  :placeholder="$t('PCUserInfo.index.647kboa05s1d')"
                  @input="formatIBAN"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <h5>{{ $t('PCUserInfo.index.647kboa096w0') }}</h5>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item :label="$t('PCUserInfo.index.647kboa09ao0')" prop="email">
                <el-input
                  v-model="form.email"
                  :placeholder="$t('PCUserInfo.index.647kboa05s1d')"
                  @input="emailChange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('PCUserInfo.index.647kboa09dk0')" prop="code">
                <!-- @blur="blur" v-model="code"-->
                <el-input
                  v-model="form.code"
                  class="yzmInput"
                  :placeholder="$t('PCUserInfo.index.647kboa05s1d')"
                  @focus="focus"
                  @blur="blur"
                >
                  <template slot="append">
                    <img v-if="isPass" src="@/assets/PC/img/true.png" alt="" class="isPass" />
                    <div
                      v-else
                      :class="['btn', !form.email || timer ? 'gray-btn' : '']"
                      @click="sendCode"
                    >
                      {{ text }}
                    </div>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="40">
            <el-col :span="24">
              <div class="declaration">
                <span>
                  {{ $t('PCUserInfo.index.declaration') }}
                </span>
                <span class="download" @click="download">
                  <i class="el-icon-download"></i> {{ $t('PCUserInfo.index.download') }}
                </span>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { lang } from '@/locales';
import { getMobileAreaCode } from '@/services/api/home';
import {
  getCities,
  getCode,
  getCountries,
  getPostCode,
  verifyCode
} from '@/services/api/settleAccount';
import { getChannelId, getNationCode } from '@/utils/channel';
export default {
  name: 'PCUserInfo',
  props: {
    dataList: Array,
    moneyData: Object,
    info: Object
  },
  data() {
    // 验证前两位必须为字母的规则
    const validateIBAN = (rule, value, callback) => {
      const rawValue = value.replace(/\s+/g, '');
      if (!/^[A-Z]{2}/.test(rawValue)) {
        callback(new Error(this.$t('PCUserInfo.index.idError')));
      } else {
        callback();
      }
    };

    const validateIDCard = (rule, value, callback) => {
      const rawValue = value.replace(/\s+/g, '');
      if (!/^[A-Za-z0-9\-/]{6,30}$/.test(rawValue)) {
        callback(new Error(this.$t('PCUserInfo.index.idError')));
      } else {
        callback();
      }
    };

    return {
      lang,
      form: {
        userName: '',
        mobile: '',
        countryCode: '',
        pinCode: '',
        city: '',
        address: '',
        idCard: '',
        // bic: '',
        iban: '',
        email: '',
        mobileAreaCode: '',
        code: ''
      },
      rules: {
        userName: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa09u40'), trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa09u40'), trigger: 'blur' }
        ],
        countryCode: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa07p80'), trigger: 'change' }
        ],
        pinCode: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa07p80'), trigger: 'change' }
        ],
        city: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa07p80'), trigger: 'change' }
        ],
        address: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa07p80'), trigger: 'change' }
        ],
        idCard: [
          { required: true, validator: validateIDCard, trigger: 'blur' }
        ],
        iban: [
          { required: true, message: this.$t('PCUserInfo.index.647kboa07p80'), trigger: 'blur' },
          { validator: validateIBAN, trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$t('PCUserInfo.index.64jjt96fg400'), trigger: 'blur' }
        ] //验证码校验
      },
      // countryList: [{ country: 'España', countryCode: 'ES', placeName: '', postCode: '' }],
      countryList: [],
      postCodeList: [],
      cityList: [],
      timer: null,
      text: this.$t('PCUserInfo.index.647kboa09z80'),
      isPass: false,
      showTip: false,
      showEmailErrorTip: false,
      alreadySend: false, // 是否发过验证码
      code: '',
      mobileAreaCode: [],
      isDownload: false,
      channel: getChannelId()
    };
  },
  computed: {
    getFlagUrl() {
      // form.mobileAreaCode
      let url = '';
      this.mobileAreaCode.forEach(item => {
        if (item.areaCode == this.form.mobileAreaCode) {
          url = item.flagUrl;
        }
      });
      return url;
    },
    // downLoadHref() {
    //   return `https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/${this.lang}_vivo_declaration.pdf`;
    // },
    downLoadHref() {
      // 根据渠道和语言返回对应的下载链接
      if (!this.channel || this.channel === '' || this.channel === '100000') {
        // 普通渠道：支持英语、西班牙语、意大利语等
        return `https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/${this.lang}_vivo_declaration.pdf`;
      } else if (this.channel === '100070') {
        // 线上渠道：支持英语和德语
        if (this.lang == 'de') {
          return 'https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/at_online_devlaration_de.pdf';
        }
        return 'https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/at_online_devlaration_en.pdf';
      } else if (this.channel === '100080') {
        // 线下渠道：只支持德语
        return 'https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/at_offline_devlaration_de.pdf';
      }
      // 默认返回英语
      return 'https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/en_vivo_declaration.pdf';
    },
    // 格式化后的 IBAN（带空格）
    formattedIBAN: {
      get() {
        return this.addSpaces(this.form.iban);
      },
      set(value) {
        // 去除空格并存储原始值
        this.form.iban = value.replace(/\s+/g, '');
      }
    }
  },
  watch: {
    form: {
      handler(newData, oldData) {
        this.$emit('completeData', this.form, this.isPass, this.isDownload);
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.getEnumList();
    // this.getCountries();
    this.getCountryListByNation()
    this.form = this.info;
    this.isDownload = this.info.isDownload || false;
    this.isPass = this.info.isPass || false;

    // 如果 mobileAreaCode 没有值，设置默认值
    if (!this.form.mobileAreaCode) {
      this.setDefaultMobileAreaCode();
    }
  },
  methods: {
    // 设置默认的手机号区号
    setDefaultMobileAreaCode() {
      const nationCode = getNationCode();

      console.log('Nation Code:', nationCode);

      // 国家码与国际区号映射
      const areaCodeMap = {
        ES: '+34', // 西班牙
        AT: '+43', // 奥地利
        DE: '+49' // 德国
      };

      const defaultAreaCode = areaCodeMap[nationCode] || areaCodeMap.ES;
      this.form.mobileAreaCode = defaultAreaCode;
    },
    /**
     * 根据国家码获取对应的国家列表
     * @param {string} nationCode - 国家码 (ES/AT/DE)
     * @returns {Array} 国家列表
     */
    getCountryListByNation() {
      const nationCode = getNationCode();
      const countryConfig = {
        ES: { country: 'España', countryCode: 'ES' },
        AT: { country: 'Österreich', countryCode: 'AT' },
        DE: { country: 'Deutschland', countryCode: 'DE' }
      };

      const config = countryConfig[nationCode] || countryConfig.ES;

      this.countryList = [
        {
          country: config.country,
          countryCode: config.countryCode,
          placeName: '',
          postCode: ''
        }
      ];
    },
    // 格式化输入（过滤非字母数字 + 转大写 + 自动加空格）
    formatIBAN(num) {
      // 1. 过滤非字母数字字符
      let value = num.replace(/[^a-zA-Z0-9]/g, '');
      // 2. 转大写
      value = value.toUpperCase();

      // 3. 更新原始值（无空格）
      this.form.iban = value;
      // 4. 重新渲染格式化后的值（带空格）
      num = this.addSpaces(value);
    },

    // 每 4 位加空格
    addSpaces(value) {
      return value.replace(/(.{4})/g, '$1 ').trim();
    },

    handleInput(num) {
      console.log(num);
      const filteredValue = num.replace(/[^a-zA-Z0-9\-\/]/g, '').toUpperCase();

      // 更新 form.idCard
      this.form.idCard = filteredValue;
    },
    download(e) {
      // e.preventDefault(); // 阻止默认行为

      fetch(this.downLoadHref)
        .then(response => response.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'declaration.pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url); // 清理
        });

      this.isDownload = true;
      this.$emit('completeData', this.form, this.isPass, this.isDownload);
    },
    getEnumList() {
      getMobileAreaCode().then(res => {
        this.mobileAreaCode = {};
        const { code, data } = res;
        if (code === '0000') {
          this.mobileAreaCode = data;
        }
      });
    },
    // 邮箱修改
    emailChange() {
      this.isPass = false;
    },
    remotePinCode(value, option) {
      this.getPostCode(value);
    },
    remoteCity(value, option) {
      this.getCities(value);
    },
    // 获取国家
    getCountries() {
      getCountries()
        .then(res => {
          const { code, data } = res;
          if (code === '0000') {
            this.countryList = data;
            this.postCodeList = [];
          }
        })
        .catch(err => {});
    },
    // 获取邮编
    getPostCode(val = '') {
      this.$set(this.form, 'pinCode', '');
      this.$set(this.form, 'city', '');
      getPostCode({
        countryCode: this.form.countryCode,
        postCode: val,
        placeName: '',
        pageNum: 1,
        pageSize: 2000
      })
        .then(res => {
          const { code, data } = res;
          if (code === '0000') {
            this.postCodeList = data.list;
            this.cityList = [];
          }
        })
        .catch(err => {});
    },
    // 获取地区
    getCities(val = '') {
      this.$set(this.form, 'city', '');
      getCities({
        countryCode: this.form.countryCode,
        postCode: this.form.pinCode,
        placeName: val
      })
        .then(res => {
          const { code, data } = res;
          if (code === '0000') {
            this.cityList = data;
          }
        })
        .catch(err => {});
    },
    resetForm() {
      this.$refs.formName.resetFields();
    },
    /**
     * 邮箱发送验证码
     */
    sendCode() {
      if (!this.form.email || this.timer) {
        return;
      }
      if (!this.form.email.includes('@')) {
        this.$message.error(this.$t('PCUserInfo.index.647kboa0ak00'));
        return;
      }
      getCode({ email: this.form.email })
        .then(res => {
          const { code } = res;
          if (code === '0000') {
            this.$message({
              message: this.$t('PCUserInfo.index.647kboa0aog0'),
              type: 'success'
            });
            this.alreadySend = true;
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                  this.text = `${this.$t('PCUserInfo.index.send')}(${this.count}s)`;
                } else {
                  this.text = this.$t('PCUserInfo.index.647kboa09z80');
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }
        })
        .catch(err => {
          if (err.response.data.code === '201') {
            this.showEmailErrorTip = true;
          }
        });
    },
    /**
     * 失焦验证邮箱验证码
     */
    blur(rule, value, callback) {
      // console.log(rule, value, callback);
      // let appendEl = document.getElementsByClassName('el-input-group__append')[0];
      // appendEl.style.borderColor = '';

      if (value === '') {
        callback(new Error(this.$t('PCUserInfo.index.64jjt96fg400')));
      } else {
        if (!this.alreadySend) {
          callback(new Error(this.$t('PCUserInfo.index.64jjt96fki00')));
          return;
        }
        const data = {
          email: this.form.email,
          verifyCode: this.form.code
        };
        verifyCode(data)
          .then(res => {
            const { code, message } = res;
            console.log('res', res);
            if (code === '0000') {
              this.isPass = true;
              this.$emit('completeData', this.form, this.isPass, this.isDownload);
            } else {
              this.isPass = false;
              this.$emit('completeData', this.form, this.isPass, this.isDownload);
              callback(new Error(message));
            }
          })
          .catch(err => {});
        // callback();
      }
    },
    focus() {
      const appendEl = document.getElementsByClassName('el-input-group__append')[0];
      appendEl.style.borderColor = '#405fff';
    }
  }
};
</script>

<style scoped lang="less">
.pc_main-info {
  width: 880px;
  border-radius: 8px;
  height: 924px;
  padding: 24px;
  background-color: #fff;
  font-size: 16px;
  color: #282828;
  padding: 40px;
  margin-bottom: 130px;
  .declaration {
    height: 48px;
    // background-color: #ebebeb;
    background-color: rgba(235, 235, 235, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px 0 10px;
    border-radius: 5px;
    font-size: 16px;
    .download {
      color: #ff9600;
      cursor: pointer;
    }
  }

  /deep/.addressInput{
    .el-input__inner{
      padding-right: 80px;
    }
  }

  /deep/.el-input__inner {
    height: 48px;
    font-size: 16px;
    // background-color: #fff!important;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    &:focus {
      border: 1px solid #405fff !important;
    }
  }
  /deep/.el-form-item__label {
    font-size: 16px;
  }

  /deep/.el-form-item.is-error .el-input__inner {
    border-color: #405fff;
  }
  .medium-div {
    font-weight: 600;
  }
  .price-main {
    height: 55px;
    h5 {
      color: var(--text-1, #252629);
      font-family: 'PingFang SC';
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px; /* 133.333% */
      margin: 0 0 20px 0;
    }
    /deep/ .el-form-item__label {
      line-height: 22px;
    }
    /deep/ .el-form-item {
      margin-bottom: 20px;
    }
    /deep/.el-row {
      margin-bottom: 20px;
    }
  }

  /deep/.el-input-group__append,
  /deep/.el-input-group__prepend {
    // background-color: no#fffne;
    background-color: #fff;
    font-size: 16px;
    color: #405fff;
  }
  /deep/.input-mobileNumber-item {
    .el-input__prefix {
      display: flex;
      align-items: center;
    }
    .el-input-group__prepend {
      .el-input__inner {
        text-align: center;
      }
    }
  }
  /deep/.yzmInput {
    .el-input__inner {
      border-right: none;
    }
    ///deep/.el-input__inner:focus {
    //  border-color: #ff9600;
    //  // border-color: #C0C4CC;
    //  // outline: 0;
    //}
    .el-input__inner:hover + .el-input-group__append,
    .el-input-group__prepend {
      border-color: #405fff !important;
      background-color: none;
    }
  }

  // /deep/.el-input.is-active .el-input__inner,
  /deep/.el-input__inner:focus {
    border-color: #405fff;
    outline: 0;
  }

  .isPass {
    width: 20px;
    height: 20px;
  }

  /deep/.el-select .el-input.is-focus .el-input__inner {
    border-color: #405fff;
  }

  /deep/.el-input__inner:hover {
    border-color: #405fff;
  }

  .btn {
    color: #405fff;
    border-radius: 10px;
    cursor: pointer;
    display: block;
    padding: 10px 0;
  }
  .gray-btn {
    opacity: 0.6;
  }
}
</style>
